import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function FamilyKidsBenefits() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1096">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1097">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-1098">
          <div data-id="element-1099">
            <img src={SITE_IMAGES.kidsClasses} alt="Kids learning Taekwondo at Storm" className="block rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-1100" />
          </div>
          <div data-id="element-1101">
            <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1102">
              For Kids
            </div>
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1103">
              Benefits for Kids
            </h2>
            <p className="text-lg text-gray-warm mb-6" data-id="element-1104">
              Training alongside a parent gives kids something rare: consistent
              reinforcement of the values they're learning. It also turns class
              time into family time.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-1105">
              {['Confidence to speak up, try new things, and bounce back from setbacks', 'Focus and discipline that show up in school and at home', 'Respect for instructors, peers, and family members', 'Real Taekwondo skills — Olympic-style, aligned with WT / Kukkiwon standards', 'Fitness, coordination, and healthy energy outlet'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1106">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-1107" />
                  <span className="text-ink" data-id="element-1108">{item}</span>
                </li>)}
            </ul>
            <Link to="/karate-kids-classes.html" className="text-storm-red font-bold hover:underline inline-flex items-center gap-1" data-id="element-1109">
              Explore Kids Classes →
            </Link>
          </div>
        </div>
      </div>
    </section>;
}